<div class="container-view">
  <app-header></app-header>
  <main>
    <div class="lg:e11-hidden">
      <app-mobile-side-drawer-menu></app-mobile-side-drawer-menu>
    </div>
    <div class="e11-container-full e11-mx-auto e11-px-6">
      <div class="layout">
        <div class="layout-navigation e11-hidden lg:e11-flex">
          <app-nav-left></app-nav-left>
        </div>
        <!-- <div class="layout-body e11-min-h-[54vh]"> -->
        <div class="layout-body e11-ml-4 e11-pr-4 md:e11-pr-0">
          <!-- Content or list items -->
          <div class="layout-content e11-mb-16">
            <ui-notification-long></ui-notification-long>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>
